'use client';

import dynamic from 'next/dynamic';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import { MapProps } from './LocationMapWrapper';
import styles from './LocationMap.module.scss';

const LocationMapWrapper = dynamic(() => import('./LocationMapWrapper'), {
  ssr: false,
  loading: () => (
    <div className={styles.mapContainer}>
      <ShimmerContainer className={styles.shimmerContainer}>
        <div />
      </ShimmerContainer>
    </div>
  )
});

const DynamicLocationMap = (props: MapProps) => {
  return <LocationMapWrapper {...props} />;
};

export default DynamicLocationMap;
